// Polyfill for packages that need global
window.global ||= window;

// Styles - use ES module imports
import 'src/styles/main.scss'
import 'react-image-lightbox/style.css'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'mobx-react'

import Routers from 'src/config/routers-new'
import AppState from 'src/stores/AppState'
import { create } from 'mobx-persist'
import { queryClient } from 'src/config/queryClient'

import { isProduction } from 'src/utils/Constants'
import { StoreProvider } from 'src/stores/useStore'
import { clearAmplitudeStorage } from 'src/utils/clearAmplitudeStorage'
import { installApiFallback } from 'src/utils/apiFallback'

// Harus dipasang sebelum ada request API: bungkus window.fetch supaya panggilan ke
// cloudfunctions.net/ukai_api otomatis beralih ke obatukai.com/ukai_api kalau domain
// cloudfunctions.net tidak terjangkau dari jaringan user.
installApiFallback()

clearAmplitudeStorage()

const hydrate = create({
  storage: localStorage,
})

const appState = new AppState();

const container = document.getElementById('root')
const root = createRoot(container)

function renderApp() {
  root.render(
    <Provider store={appState}>
      <StoreProvider store={appState}>
        <QueryClientProvider client={queryClient}>
          <Routers />
        </QueryClientProvider>
      </StoreProvider>
    </Provider>
  )
}

hydrate('obatukai', appState)
  .catch((err) => {
    console.error('Failed to hydrate store', err)
  })
  .then(() => {
    appState.authenticating = true
    renderApp()
  })
